export default "__VITE_ASSET__DB1x4cKX__"